// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2oQJQ","detailsBorder":"styles_detailsBorder__1kCYr"};